export const getCurrentContactDetails = (state) => state.auth.currentContact;

export const getCurrentContactEmail = (state) =>
  getCurrentContactDetails(state).ifSuccess(
    (currentContact) => currentContact?.contactDetails.email,
  ) || null;
